export enum ProsecutionTextSection {
	Introduction = "introduction",
	Reasons = "reasons",
	Requests = "requests",
}
